const _ = require('lodash');
require('./prototypes.js');

import gradeMapJson from './data/gradeMap.json';

const gradeMap = Object.values(gradeMapJson).reduce((acc, x) => acc.concat(x), []);
const moment = require('moment');

import storeHelpers from './storeHelpers.js';
import error from './error.js';
// import scrollToAnimated from './scrollToAnimated';

let resourceTypes = {
    'assessment': {
        'image' : 'annotation_interactive.png',
        'name' : 'Assessment'
    },
    'image': {
        'image' : 'annotation_graphic.png',
        'name' : 'Image'
    },
    'pdf': {
        'image' : 'annotation_pdf.png',
        'name' : 'PDF'
    },
    'text': {
        'image' : 'annotation_text.png',
        'name' : 'Text'
    },
    'url': {
        'image' : 'annotation_url.png',
        'name' : 'Link'
    },
    'video': {
        'image' : 'annotation_video.png',
        'name' : 'Video'
    },
    'audio': {
        'image' : 'annotation_audio.png',
        'name' : 'Audio'
    },
    'powerpoint': {
        'image' : 'annotation_office_powerpoint.png',
        'name' : 'PowerPoint'
    },
    'word': {
        'image' : 'annotation_office_word.png',
        'name' : 'Word'
    },
    'excel': {
        'image' : 'annotation_office_excel.png',
        'name' : 'Excel'
    },
    'flashcarddeck': {
        'image' : 'annotation_flashcards.png',
        'name' : 'Flashcard decks'
    },
    'educatorflashcarddeck': {
        'image' : 'annotation_flashcards.png',
        'name' : 'Educator decks'
    },
    'personalflashcarddeck': {
        'image' : 'annotation_flashcards.png',
        'name' : 'My decks'
    },
    'drawing': {
        'image' : 'annotation_sketch.png',
        'name' : 'Drawing'
    },
    'note': {
        'image' : 'annotation_note.png',
        'name' : 'Note'
    },
    'sketch': {
        'image' : 'annotation_sketch.png',
        'name' : 'Freehand Sketch'
    },
    'googledrive': {
        'image' : 'annotation_googledrive.png',
        'name' : 'Google Drive File'
    }
};

_.each(Object.keys(resourceTypes), function(type) {
    resourceTypes[type].type = type;
})

let resourceTypeURLImageMapping = {
    "digg.com" : "itsi_url_digg.png",
    "dropbox.com" : "itsi_url_dropbox.png",
    "evernote.com" : "itsi_url_evernote.png",
    "facebook.com" : "itsi_url_facebook.png",
    "github.com" : "itsi_url_github.png",
    "github.io" : "itsi_url_github.png",
    "drive.google.com" : "itsi_url_google_drive.png",
    "docs.google.com" : "itsi_url_google_drive.png",
    "instagram.com" : "itsi_url_instagram.png",
    "linkedin.com" : "itsi_url_linkedin.png",
    "microsoft.com" : "itsi_url_microsoft.png",
    "onenote.com" : "itsi_url_onenote.png",
    "pinterest.com" : "itsi_url_pinterest.png",
    "pin.it" : "itsi_url_pinterest.png",
    "reddit.com" : "itsi_url_reddit.png",
    "scribd.com" : "itsi_url_scribd.png",
    "siyavula.com" : "itsi_url_siyavula.png",
    "everythingmaths.co.za" : "itsi_url_siyavula.png",
    "intelligentpractice.co.za" : "itsi_url_siyavula.png",
    "slideshare.net" : "itsi_url_slideshare.png",
    "stackoverflow.com" : "itsi_url_stackoverflow.png",
    "tumblr.com" : "itsi_url_tumblr.png",
    "pinterest.com" : "itsi_url_pinterest.png",
    "vimeo.com" : "itsi_url_vimeo.png",
    "vine.com" : "itsi_url_vine.png",
    "wikipedia.org" : "itsi_url_wikipedia.png",
    "wikimedia.org" : "itsi_url_wikipedia.png",
    "youtu.be" : "itsi_url_youtube.png",
    "youtube.com" : "itsi_url_youtube.png"
}

const funcs = {
    getAllResourceTypes: function (excludeTypes) {
        var resourceTypesClone =  Object.assign({}, resourceTypes);

        if(excludeTypes) {
            _.each(excludeTypes, function(type) {
                delete resourceTypesClone[type];
            });
        }
        
        return resourceTypesClone;
    },
    resourceTypeImg: function (type, url = null) {
        if(!type) return null; 
        
        if ((type === "url" || type === "url_internal") && url != null) {
            const specificURLImage = Object.keys(resourceTypeURLImageMapping).find(function(key){
                if(url.includes(key)) return resourceTypeURLImageMapping[key]
            }); 
            
            if(specificURLImage) {
                return `static/img/resource-types/${resourceTypeURLImageMapping[specificURLImage]}`;
            }
        }

        if(!resourceTypes[type]) {
            console.warn('Unknown resource type', type);
            return "";
        } 
        const file = resourceTypes[type].image;
        if (!file) console.warn('Unknown resource type', type);
        return file ? `static/img/resource-types/${file}` : null;
    },
    resourceTypeImgNoPath: function (type, url = null) {
        return funcs.resourceTypeImg(type, url).replace("static/img/resource-types/", "").replace(".png","");
    },
    determineResourceCategory(filename) {
        var category = "";

        var pathExtension = filename.substr(filename.lastIndexOf('.') + 1).toLowerCase();

        switch (pathExtension) {
            case "png":
            case "jpg":
            case "jpeg":
                category = "image";
                break;
            case "txt":
                category = "text";
                break;
            case "url":
                category = "url";
                break;
            case "mp4":
                category = "video";
                break;
            case "mp3":
            case "mpeg":
                category = "audio";
                break;
            case "zip":
                category = "assessment";
                break;
            case "pdf":
                category = "pdf";
                break;
            case "docx":
            case "doc":
                category = "word";
                break;
            case "xlsx":
            case "xls":
                category = "excel";
                break;
            case "pptx":
            case "ppt":
                category = "powerpoint";
                break;
            case "flashcarddeck":
                category = "flashcarddeck"
            break;
            default:
                category = ""
        }

        return category;
    },
    isAnnotation(resource) {
        return resource && resource.category && (resource.category.toLowerCase() === "googledrive" || resource.category.toLowerCase() === "note" || resource.category.toLowerCase() === "sketch" || resource.category.toLowerCase() === "drawing");
    },
    gradeLookup: function (g) {
        const section = gradeMap.find(x => x.value === g);
        return section ? section.name : g;
    },
    stringToBgRGBAColorArray: function (str, opacity = 60) {
        const colorsArray = ["88d958", "20948b", "ff410d", "336b86", "7d152e", "8fafc4",
            "d41600", "004445", "ecad00", "240041", "FF4057", "702283", "76B39D", "FDB44B",
            "FF6107", "E9290F", "B32C50", "0A0944", "08C299", "cddc39", "2196f3", "f98765"];
    
        const hashCode = function (strToHash) {
            let hash = 0;
            for(let i = 0; i < strToHash.length; i++)
                hash = (strToHash.charCodeAt(i) + ((hash << 5) - hash)) & 0xFFFFFFFF;
            return hash;
        };
    
        const i = Math.abs(hashCode(str));
    
        const bgColor = colorsArray[i % (colorsArray.length - 1)];
        const r = parseInt(bgColor.substr(0, 2), 16);
        const g = parseInt(bgColor.substr(2, 2), 16);
        const b = parseInt(bgColor.substr(4, 2), 16);
        const o = opacity / 100;
    
        return [r, g, b, o];
    },
    getFeedFontAwesomeName: function (event_name) {
        if (event_name.indexOf("Archive") >= 0) return "archive";
        if (event_name ==="FocusLost" || event_name ==="Closed" || event_name ==="Crashed") return "arrow-circle-left";
        if (event_name ==="FocusGained" || event_name ==="Started") return "arrow-circle-right";
        if (event_name ==="Library") return "book";
        if (event_name ==="PageOpen") return "file";
        if (event_name ==="Settings" || event_name ==="Accounts") return "users";
        if (event_name ==="UpcomingEvents") return "calendar";
        if (event_name.indexOf("Summary") >= 0) return "list-alt";
        if (event_name ==="SwitchAccount") return "exchange";
        if (event_name ==="BookDownload") return "download";
        if (event_name.indexOf("Search") >= 0) return "search";
        if (event_name.indexOf("Flashcard") >= 0) return "file-check";
        if (event_name.indexOf("Freeform" >= 0) || event_name.indexOf("Folder" >= 0)) return "folder";
        if (event_name ==="Annotation") return "edit";
        if (event_name.indexOf("Resource" >= 0) || event_name.indexOf("Attachment") >= 0) return "paperclip";
        if (event_name ==="NewsLetter") return "newspaper";
        if (event_name.indexOf("Stats" >= 0)) return "chart-bar";
        if (event_name.indexOf("File" >= 0)) return "file";
        if (event_name ==="WhatsNew") return "gift";
        if (event_name ==="Highlight") return "highlighter";
        if (event_name.indexOf("URL" >= 0) || event_name.indexOf("Practice" >= 0)) return "globe";
    },
    floor: function (value, precision) {
        const multiplier = Math.pow(10, precision || 0);
        return Math.floor(value * multiplier) / multiplier;
    },
    getYFromSelector: function(handle, selector, bodyAndWindowHandles) {
        var {bodyHandle, windowHandle} = bodyAndWindowHandles;
        try {
            var el = bodyHandle.querySelectorAll(selector);
            if (el.length > 0) {
                return (windowHandle.scrollY + el[0].getBoundingClientRect().top);
            } else {
                error.logError(handle, "No element to scroll to for selector: " + selector);
            }
            return 0;
        } catch (error) {
            funcs.log(handle, error)
        } 
    },
    nl2br: function(str) {
        return str.replaceAll("\r\n","<br />").replaceAll("\n","<br />").replaceAll("\r","<br />");
    },
    removeElementsByClass: function(className, doc){
        var elements = doc.getElementsByClassName(className);
        while(elements.length > 0){
            elements[0].parentNode.removeChild(elements[0]);
        }
    },
    getOffset: function(el) {
        const rect = el.getBoundingClientRect();
        return {
          left: rect.left + window.scrollX,
          top: rect.top + window.scrollY
        };
    },
    watchStoreProperty: function(handle, storePropertyName, callback) {
        var callbackDebounced = _.debounce(callback, 1000)
        var unwatchFunction = handle.$store.watch((state, getters) => state[storePropertyName],
            (newValue, oldValue) => {
                callbackDebounced(newValue);
            },
        );

        callbackDebounced(handle.$store.state[storePropertyName])
        return unwatchFunction;
    },
    watchStorePropertiesWithCallback: function(handle, storePropertyNames, callback) {
        var unwatchFunctions = [];

        var callbackDebounced = _.debounce(callback, 1000)
        _.each(storePropertyNames, function(storePropertyName){
            unwatchFunctions.push(
                handle.$store.watch((state, getters) => state[storePropertyName],
                    (newValue, oldValue) => {
                        callbackDebounced(storePropertyName, newValue);
                    },
                )
            );
        });

        callbackDebounced('init', {});

        return unwatchFunctions;
    },
    getFormattedDate: function(momentDate) {
        return momentDate.format("D MMM 'YY h:mm a");
    },
    hasInternetConnection: function() {
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      return navigator.onLine || (connection && connection.type !== "none");
    },
    GUID: function() {
        var d = new Date().getTime();
        if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
            d += performance.now(); //use high-precision timer if available
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    },
    stringToBgRGBAColorLight: function(val, opacity = 60) {
        return "rgba(" + funcs.stringToBgRGBAColorArray(val, opacity).join(",") + ")";
    },
    stringToBgRGBAColor: function(val, opacity = 80) {
        return "rgba(" + funcs.stringToBgRGBAColorArray(val, opacity).join(",") + ")";
    },
    truncateString: function (str, num) {
        if (str.length > num) {
            return str.slice(0, num) + "...";
        } else {
            return str;
        }
    },
    truncateStringAccordingToWidth: function (str, width) {
        var total = Math.ceil(width / 16);
        if (str.length > total) {
            return str.slice(0, Math.ceil(total)) + "...";
        } else {
            return str;
        }
    },
    epubSearchTruncateString: function(str, num) {
        if (str.length > num) {
            return "..." + str.slice(Math.floor(str.length * (num / 200)), Math.floor((str.length - str.length * (num / 200)))) + "...";
        } else {
            return str;
        }
    },
    getNavName: function(id, handle, plural, defaultName, deviceFeatures) {
        var navItem = funcs.getNavItem(id, deviceFeatures ? deviceFeatures : handle.$store.state.deviceFeatures);
        if(navItem && navItem.pluralName && navItem.customName) {
            if(plural) {
                return navItem.pluralName;
            } else {
                return navItem.customName;
            }
        } else {
            return defaultName;
        }
    },
    getNavItem(id, deviceFeatures) {
        return _.find(deviceFeatures.navigation, function(navItem) {
            return navItem.id === id;
        });
    },
    isNavItemActive(id, deviceFeatures) {
        var foundNav = funcs.getNavItem(id, deviceFeatures);

        return !foundNav || foundNav.active;
    },
    shouldTextBeBlack: function(bgColor) {
        if(bgColor.length === 3) {
            bgColor = bgColor + bgColor;
        }

        const r = parseInt(bgColor.substr(0, 2), 16);
        const g = parseInt(bgColor.substr(2, 2), 16);
        const b = parseInt(bgColor.substr(4, 2), 16);
        const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

        return (yiq >= 122);
    },
    getContrastYIQ: function (hexcolor){
        var r = parseInt(hexcolor.substr(0,2),16);
        var g = parseInt(hexcolor.substr(2,2),16);
        var b = parseInt(hexcolor.substr(4,2),16);
        var yiq = ((r*299)+(g*587)+(b*114))/1000;
        return (yiq >= 128) ? 'black' : 'white';
    },
    getDate: function(epoch) {
        return moment.unix(epoch).format('MMMM D, YYYY');
    },
    openResource: function(handle, resource, attachmentIds, options={}) {
        if(funcs.isAnnotation(resource))
            return;
        
        if (resource.category === "url") {
            window.open(resource.url, '_blank');
            return;
        }
        var resourceId = resource._id ? resource._id : resource.id;
        var url = '?res=' + resourceId;

        if(options && options.from) {
            url += '&f=' + options.from;
        }

        if(attachmentIds) {
            // single attachment or assessment
            if ((attachmentIds.length === 1) || (attachmentIds.length > 1 && resource.category === "assessment")) {
                url += '&att=' + attachmentIds[0];
            }
        }

        handle.$router.push(url)
    },
    openResourceById: function(handle, resourceId, attachmentIds, location) {
        var resource = storeHelpers.getResourceById(handle, resourceId)
        if(!resource) return;

        funcs.openResource(handle, resource, attachmentIds, location);
    },
    openFlashcardDeckById: function(handle, flashcarddeckId, callback) {
        axios.get( handle.$config.get('ecApi') + "resources/" + flashcarddeckId + "/data")
        .then(function(res) {
            callback(res);
        }).catch(function(error){
            console.error(error);
        })
    },
    downloadSummary: function (data, filename, mime) {
        var blob = new Blob([data], {type: mime || 'application/octet-stream'});
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // IE workaround for "HTML7007: One or more blob URLs were 
            // revoked by closing the blob for which they were created. 
            // These URLs will no longer resolve as the data backing 
            // the URL has been freed."
            window.navigator.msSaveBlob(blob, filename);
        }
        else if(iOS) {
            var reader = new FileReader();
            reader.onload = function(e){
                window.location.href = reader.result;
            }
            reader.readAsDataURL(blob);
        }
        else {
            var blobURL = window.URL.createObjectURL(blob);
            var tempLink = document.createElement('a');
            tempLink.style.display = 'none';
            tempLink.href = blobURL;
            tempLink.setAttribute('download', filename); 

            // Safari thinks _blank anchor are pop ups. We only want to set _blank
            // target if the browser does not support the HTML5 download attribute.
            // This allows you to download files in desktop safari if pop up blocking 
            // is enabled.
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank');
            }

            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }
    },
    downloadFile: function (fileURL, fileName) {
        // for non-IE
        if (!window.ActiveXObject) {
            var save = document.createElement('a');
            save.href = fileURL;
            save.target = '_blank';
            var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
            save.download = fileName || filename;
            if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                document.location = save.href; 
            }else{
                var evt = new MouseEvent('click', {
                    'view': window,
                    'bubbles': true,
                    'cancelable': false
                });
                save.dispatchEvent(evt);
                (window.URL || window.webkitURL).revokeObjectURL(save.href);
            }	
        }
    
        // for IE < 11
        else if ( !! window.ActiveXObject && document.execCommand) {
            var _window = window.open(fileURL, '_blank');
            _window.document.close();
            _window.document.execCommand('SaveAs', true, fileName || fileURL)
            _window.close();
        }
    },
    getBookLink: function(book, currentPage) {
        if (book.requirePurchase) {
            return "";
        } else {
            return '/book/' + book.id + "/" + currentPage;
        }
    },
    base64ToByteArray: function(base64String) {
        const decodedBase64String = atob(base64String);
        const byteArray = new Array(decodedBase64String.length);
        for (let i = 0; i < decodedBase64String.length; i++) {
            byteArray[i] = decodedBase64String.charCodeAt(i);
        }
        return byteArray;
    },
    base64ToArrayBuffer: function(base64) {
        var binary_string =  window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array( len );
        for (var i = 0; i < len; i++)        {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    },
    uint8ToBase64: function (u8Arr){
        var CHUNK_SIZE = 0x8000; //arbitrary number
        var index = 0;
        var length = u8Arr.length;
        var result = '';
        var slice;
        while (index < length) {
          slice = u8Arr.subarray(index, Math.min(index + CHUNK_SIZE, length)); 
          result += String.fromCharCode.apply(null, slice);
          index += CHUNK_SIZE;
        }
        return btoa(result);
    },
    uriEncode:function (str) {
        return encodeURIComponent(str);
    },
    isParentApp: function() {
        return window.location.pathname.startsWith('/parent')
    },
    goHome: function(handle) {
        if(window.location.pathname === "/" || window.location.pathname === "/reader" || window.location.pathname === "/reader/") {
            window.location.replace(handle.$config.get('basePathFiles') + "library");
        }
        else if(window.location.pathname === "/parent" || window.location.pathname === "/parent/") {
            window.location.replace(handle.$config.get('basePathFiles') + "feed");
        }
    },
    getServerTime: async function(handle, callback) {
        var t = handle;
        var url = t.$config.get("dns") + "/educator/time";

        return await axios.get(url)
        .then(response => {
            callback(moment(response.data * 1000))
        })
        .catch(e => {
            error.check401And498(t, e);
            callback({
                error:
                    error.logAndGetError(t, e) + "while checking the server time."
            });
        });
    },
    log: function(handle, msg, obj) {
        if (handle.$config.get('localServer')) {
            if (obj)
                console.log(msg, obj);
            else
                console.log(msg);
        }
    },
    filterLockedResources: function (handle, attachments) {

        // group attachments by lp
        var attachmentsWithLp = _.filter(attachments, attachment => {
            if (attachment.lp) return true
            else return false
        })
        if (attachmentsWithLp.length == 0) {
            return attachments
        }
        var attachmentsByLP = _.groupBy(attachmentsWithLp, attachment => {
            return attachment.lp
        })

        // var deepcopy = JSON.parse(JSON.stringify(attachmentsByLP))

        // console.log("deepcopy", deepcopy)
        // console.log("deepcopy:", deepcopy)
        for (var lp in attachmentsByLP) {
            const attachmentsForLP = storeHelpers.getLPData(handle, lp);
            // console.log("lp:", lp)
            _.each(attachmentsByLP[lp], (attachment, attachmentIndex) => {
                // console.log("attachment:", attachment)
                _.each(attachmentsForLP.lpItems, item => {
                    // console.log("item:", item, attachment._id === item.attachment && item.locked && item.visible)
                    if (attachment._id === item.attachment && item.locked && item.visible) {
                        attachmentsByLP[lp][attachmentIndex].locked = true;
                        attachmentsByLP[lp][attachmentIndex]
                        // console.log('attachmentLocked:', attachmentsByLP[lp][attachmentIndex])
                        // if (attachment._id == "attachment-6476cb44-de44-4a33-92c0-c571b335a98d")
                        //     console.log('test:', attachment)
                    }
                });
            })
            
        }

        // _.each(attachments, attachment => {
        
            // if (attachment && attachment.lp) {
            //     const attachmentsForLP = storeHelpers.getLPData(handle, attachment.lp);
            //     _.each(attachmentsForLP.lpItems, item => {
            //         if (attachment._id === item.attachment && item.locked && item.visible) {
            //             attachment.locked = true;
            //         }
            //     });
            // }
        // });
        // return attachment;
        
        var filteredAttachements = []
        for (var lp in attachmentsByLP) {
            filteredAttachements.push(attachmentsByLP[lp])
        }
        // console.log("filteredAttachements:", filteredAttachements.flat())
        return filteredAttachements.flat()
    }
}

export default funcs;
